import _ from 'lodash'
import React, { useEffect } from 'react'
import { compose } from 'recompose'

import { withSupportedReligionsService, withSupportedReligionsServiceProps } from 'services/supportedReligions'

import { Select } from 'components'
import { SelectProps } from 'components/Select/Select'

import i18n from 'translations'

import withInfiniteDropdownHelpers, {
  withInfiniteDropdownHelpersProps,
} from '../../legacy/InfiniteDropdowns/withInfiniteDropdown'
import { DropdownProps } from '../InfiniteDropdownsModel'

export type SupportedReligionsDropdownProps = withInfiniteDropdownHelpersProps
  & withSupportedReligionsServiceProps
  & SelectProps<any>
  & DropdownProps

const SupportedReligionsDropdown: React.FC<SupportedReligionsDropdownProps> = ({
  extraFields,
  infiniteDropdownHelpers,
  onChange,
  placeholder,
  supportedReligionsActions,
  value,
  ...rest
}) => {
  useEffect(() => {
    if (value) {
      infiniteDropdownHelpers.handleComponentDidMountOnSuccess({
        data: {
          id: _.isObject(value) ? (value as any)?.value : value,
          name: _.isObject(value) ? (value as any)?.label : i18n.t(`components:ChildForm:Religion:${value}`),
        },
      })
    }
  }, [])

  const listAction = ({ newPage, newSearchPhrase, result }) => supportedReligionsActions.dropdownList({
    onSuccess: (response) => infiniteDropdownHelpers.handleLoadMoreElementsOnSuccess({
      extraFields,
      newPage,
      newSearchPhrase,
      response: {
        data: _.map(response.data, (item) => ({
          id: item,
          name: i18n.t(`components:ChildForm:Religion:${item}`),
        })),
      },
      result,
    }),
    onlyData: true,
    params: {
      page: newPage,
    },
  })

  return (
    <Select
      {...infiniteDropdownHelpers.getSelectRestParams({ onChange, value, ...rest })}
      loadOptions={infiniteDropdownHelpers.handleLoadMoreElementsV2({ listAction })}
      placeholder={placeholder || i18n.t('components:InfiniteDropdowns:SupportedReligions:placeholder')}
      searchable
    />
  )
}

const enhance = compose(
  withSupportedReligionsService,
  withInfiniteDropdownHelpers,
)

export default enhance(SupportedReligionsDropdown)
